import script from "./utility-switching-council-nav-menu.vue?vue&type=script&setup=true&lang=ts"
export * from "./utility-switching-council-nav-menu.vue?vue&type=script&setup=true&lang=ts"

import "./utility-switching-council-nav-menu.vue?vue&type=style&index=0&id=518c6de0&lang=scss"

const __exports__ = script;

export default __exports__